import Vue from 'www/vue_components'
import I18NextVue from 'i18next-vue'
import vuetify from 'www/modules/vuetify-plugin'
import { createPinia } from 'pinia'
import { initI18n, makeElementSticky } from 'www/utils'
import TheDoctorsFilters from 'www/vue_components/common/TheFilters/doctors/TheDoctorsFilters.vue'

const mountElement = document.querySelector('.vue-the-doctors-filters')
const topLimitInvisible = mountElement instanceof HTMLElement ? mountElement.offsetTop + mountElement.clientHeight : 0

async function mountFilters() {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/TheFilters' })

  Vue.use(I18NextVue, { i18next })

  if (mountElement) {
    new Vue({
      vuetify,
      el: mountElement,
      pinia: createPinia(),
      components: {
        TheDoctorsFilters,
      },
    })

    makeElementSticky({
      el: '.vue-the-doctors-filters',
      offset: window.MOBILE_VERSION ? 104 : 0,
      topLimitInvisible,
    })
  }
}

mountFilters()
